export function kebabToPascalCase(text: string) {
    // Use a regular expression to match the first character of the string (^\w)
    // or a word character that follows a hyphen (-\w) globally.
    return text.replace(/(^\w|-\w)/g, clearAndUpper);
}

export function makeLink(pageName: string, mode: 'lib' | 'html' | 'dev'): string {
    const isIndex = !pageName || pageName === 'index';
    if (mode === 'html') {
        return isIndex ? `/index.html` : `/index.html?page=${pageName}`;
    } else {
        return isIndex ? `/` : `/${pageName}`;
    }
}
export function findAncestorByClass(inner: HTMLElement, className: string): HTMLElement | null {
    for (var elem = inner.parentElement; elem; elem = elem.parentElement) {
        if (elem.classList.contains(className)) {
            return elem;
        }
    }
    return null;
}

//*
// Get the parent element of a given element, skipping any intermediate TEMPLATE or SCRIPT tags
// This is useful for initializers that are mounted on TEMPLATE or SCRIPT tags but need to interact with their parent container
//
export function getParentContainer(inner: HTMLElement): HTMLElement {
    let elem = inner.parentElement!;
    if (elem?.tagName === 'TEMPLATE' || elem?.tagName === 'SCRIPT') {
        elem = elem.parentElement!;
    }
    return elem;
}

export function trimByWords(text: string, maxWords: number): string {
    const strippedString = text.trim();
    const array = strippedString.split(' ');
    let _newText = array.splice(0, maxWords).join(' ');

    if (array.length > maxWords) {
        _newText += '...';
    }
    return _newText;
}

export function loadScript(url: string, callback?: () => void) {
    const script = document.createElement('script');
    script.src = url;
    if (callback) {
        script.onload = callback;
    }
    document.head.appendChild(script);
}

function clearAndUpper(text: string): string {
    // A helper function to remove the hyphen and capitalize the following character.
    // It handles both the initial character match and the hyphenated matches.
    return text.replace(/-/, '').toUpperCase();
}
